import { FormSubmissionErrors } from './custom-errors'
import { RsvpStatus } from './types/types'
import { RsvpStatus as V2RsvpStatus } from '@wix/ambassador-events-v2-rsvp/types'

export const toV2RsvpStatus = (status: RsvpStatus): V2RsvpStatus => {
	switch (status) {
		case RsvpStatus.YES:
			return V2RsvpStatus.YES
		case RsvpStatus.NO:
			return V2RsvpStatus.NO
		case RsvpStatus.WAITING:
			return V2RsvpStatus.WAITLIST
	}
}

export const toCorvidRsvpStatus = (status?: V2RsvpStatus): RsvpStatus | undefined => {
	if (!status) {
		return undefined
	}

	switch (status) {
		case V2RsvpStatus.YES:
			return RsvpStatus.YES
		case V2RsvpStatus.NO:
			return RsvpStatus.NO
		case V2RsvpStatus.WAITLIST:
			return RsvpStatus.WAITING
		case V2RsvpStatus.UNKNOWN_RSVP_STATUS:
			return undefined
	}
}

export const V2_TO_FORM_SUBMISSION_ERROR: Partial<Record<string, FormSubmissionErrors>> = {
	GUEST_LIMIT_EXCEEDED: FormSubmissionErrors.GUEST_LIMIT_REACHED,
	RSVPS_CLOSED: FormSubmissionErrors.RSVP_CLOSED,
	RSVPS_NOT_STARTED: FormSubmissionErrors.REGISTRATION_CLOSED,
	WAITING_LIST_UNAVAILABLE: FormSubmissionErrors.WAITING_LIST_UNAVAILABLE,
	MEMBER_ALREADY_REGISTERED: FormSubmissionErrors.MEMBER_ALREADY_REGISTERED,
}
